<div [ngClass]="{
    'bg-[#E9F3FB]': isHomePage,
    'bg-white dark:bg-second-dark': !isHomePage
  }" class="min-h-screen transition-colors duration-300 dark:bg-primary-dark">
  @if (isPaymentPage) {
  <nav
    class="bg-[#EFF5FD] not-last-of-type:relative z-50 container max-w-full mx-auto px-4 py-4 flex justify-between items-center dark:bg-transparent cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <a routerLink="/">
      <img class="w-30 md:w-40" src="/icons/BlueLogo.svg" alt="logo" />
    </a>
    <button
      class="flex justify-center items-center gap-1 px-4 w-fit py-2 rounded-lg bg-[#369BE7] text-white font-medium"
      (click)="goBack()">
      <h5 class="font-medium text-white">
        {{ "Shared.Back" | translate }}
      </h5>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        class="font-normal text-white text-sm rtl:-rotate-180 ltr:rotate-180">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </nav>
  } @else if (!isBusinessPage) {

  <app-main-nav-bar [isHomePage]="isHomePage" [isOverlayed]="isOverlayed" />
  }
  <div class="-mb-4 min-h-screen flex flex-col">
    <app-loader />

    <router-outlet></router-outlet>

    <app-network-error />
  </div>
  @if (!isBusinessPage) {
  <app-main-footer />
  }
</div>